import React from 'react';
import TinySliderWrapper from "tiny-slider-react-wrapper";
import '../assets/styles/components/Sponsors.sass';

const Sponsors = ({ customClass, items }) => {
  const settings = {
    lazyload: true,
    items: 2,
    nav: false,
    controls: false,
    mouseDrag: true,
    speed: 700,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 2000,
    autoplayButtonOutput: false,
    responsive: {
      600: {
        items: 3
      },
      900: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  };

  return (
    <div className={`row Sponsors ${customClass}`}>
        <div className="col-12 text-center">
          <TinySliderWrapper settings={settings}>
            {items.map(item => (
              <div key={item.id}>
                <a href={item.web} target="blank">
                  <img
                    className="img-fluid"
                    src={`https://legendofeldorado.com/series-admin-temporal/img/marcas_in/${item.logo_mono}`}
                    alt=""
                    onMouseOut={e => (e.currentTarget.src = `https://legendofeldorado.com/series-admin-temporal/img/marcas_in/${item.logo_mono}`)}
                    onMouseOver={e => (e.currentTarget.src = `https://legendofeldorado.com/series-admin-temporal/img/marcas_in/${item.logo}`)}
                  />
                </a>
              </div>
            ))}
          </TinySliderWrapper>
        </div>
    </div>
  );
}

export default Sponsors;
